/* eslint-disable camelcase */
// TODO: [PROF-5358] Bring back analytics page with tabs, routing etc.

// import { values } from "lodash";
// import { ScheduleFrequency } from "PFApp/analytics/types/export_analytics";
import { useQueryClient } from "@tanstack/react-query";
import { useGrowl } from "PFApp/use_growl";
import { Typography } from "PFComponents/typography";
import { usePusherEvent } from "PFCore/base/pusher";
import { queryKeys } from "PFCore/hooks/queries/analytics/query_keys";
import { useReport, useReports } from "PFCore/hooks/queries/analytics/use_reports";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import { Report } from "../../types/reports";
import css from "./reports_page.module.scss";
import { ReportsTable } from "./reports_table/reports_table";
// import { ReportsTableTabs, TabItem } from "./reports_table_tabs";

const REFETCH_INTERVAL_MS = 2 * 60 * 1000;

export enum ReportsTableTab {
  All = "all",
  Bookmarked = "bookmarked",
  TopReports = "top_reports",
  Scheduled = "scheduled",
  NotScheduled = "not_scheduled"
}

export const ReportsPage = () => {
  const [selectedTab] = useState(ReportsTableTab.All);
  const { data: reportsData, isLoading: reportsIsLoading } = useReports({
    enabled: true,
    refetchInterval: REFETCH_INTERVAL_MS
  });
  const { data: currentProfile } = useCurrentProfile();
  const queryClient = useQueryClient();
  const [reportDownloadId, setReportDownloadId] = useState();
  const { data: exportedReport } = useReport(reportDownloadId!, {
    enabled: !!reportDownloadId
  });
  const growl = useGrowl();
  const { t } = useTranslation(["insights", "translation"]);

  const reportLink = useMemo(() => exportedReport?.versions[0].downloadUri, [exportedReport]);

  const handleRefetchReports = useCallback(
    ({ download_id }) => {
      queryClient.invalidateQueries(queryKeys.reports);
      if (download_id) {
        setReportDownloadId(download_id);
      }
    },
    [queryClient]
  );

  usePusherEvent(
    `private-account-${currentProfile.id}`,
    "new-report-download-available",
    handleRefetchReports
  );

  useEffect(() => {
    if (reportLink) {
      growl({
        kind: "success",
        message: (
          <Typography variant="bodyBold" noMargin>
            {`${exportedReport?.name} ${t("insights:exportWizard.generateSuccess")}`}
          </Typography>
        ),
        buttonText: t("translation:download"),
        buttonHref: reportLink
      });
    }
  }, [reportLink, exportedReport?.name, growl, t]);

  // const counters = useMemo(() => {
  //   if (!reportsData) {
  //     return undefined;
  //   }
  //   return {
  //     [ReportsTableTab.All]: reportsData.meta.total || 0,
  //     [ReportsTableTab.Scheduled]: reportsData.entries.filter(
  //       (entry) => entry.schedule?.repeat !== ScheduleFrequency.No
  //     ).length,
  //     [ReportsTableTab.NotScheduled]: reportsData.entries.filter(
  //       (entry) => entry.schedule?.repeat === ScheduleFrequency.No
  //     ).length,
  //     [ReportsTableTab.Bookmarked]: 0, // change when API ready
  // TODO: [PROF-4709] [ReportsTableTab.TopReports]: 0
  //   };
  // }, [reportsData]);

  return (
    <div className={css.reportsContainer}>
      <div className={css.tableContainer}>
        {/* <ReportsTableTabs
          selectedTab={selectedTab}
          tabs={values(ReportsTableTab).map((key: ReportsTableTab) => ({
            name: key,
            count: counters ? counters[key] : 0
          }))}
          onChange={(tab: TabItem) => setSelectedTab(tab.name)}
        /> */}
        <ReportsTable
          reports={(reportsData?.entries as Report[]) ?? []}
          isLoading={reportsIsLoading}
          selectedTab={selectedTab}
        />
      </div>
    </div>
  );
};
